import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

/** Canonical host - works once www DNS points at Hostinger (see public/.htaccess). */
if (typeof window !== 'undefined' && window.location.hostname === 'www.manedesign.in') {
  const target = `https://manedesign.in${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(target);
} else {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}